import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LanguageToggle from "./LanguageToggle";

export default function Navbar() {
  const [showNavbart, setShowNavbart] = useState(false);
  const { isAuthenticated, logout, user } = useAuth();
  const navigate = useNavigate();

  const getDashboardPath = () => {
    if (!user || !user.role) return '/farmer-dashboard';
    const userRole = user.role.toLowerCase();
    switch (userRole) {
      case 'expert':
        return '/expert-dashboard';
      case 'retailer':
        return '/retailer-dashboard';
      case 'farmer':
      default:
        return '/farmer-dashboard';
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
      offset: 100,
    });
  }, []);

  const toggleNavbart = () => {
    setShowNavbart(!showNavbart);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="bigger-nav" data-aos="fade-down" data-aos-duration="1000">
      <div className={`dark-body-t ${showNavbart ? "visible" : ""}`} onClick={toggleNavbart}></div>

      <div className={`absolute-navbar ${showNavbart ? "visible" : ""}`}>
        <div className="logo-nav">
           <img
            src="/AGRICVERSE_LOGO.png"
            alt="AgricVerse Logo"
            style={{ height: 40, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />

          <i className="fas fa-close" onClick={toggleNavbart}></i>
        </div>
        <ul>
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/about">About</a>
          </li>
          <li>
            <a href="/marketplace">Marketplace</a>
          </li>
          <li>
            <a href="mailto:support@agricverse.com">Contact</a>
          </li>
        </ul>
        <div className="signup-nav-btn shonw">
          <LanguageToggle />
          {isAuthenticated ? (
            <>
              <span className="user-welcome">Welcome, {user?.user_name || 'User'}</span>
              <button onClick={() => navigate(getDashboardPath())}>Dashboard</button>
            </>
          ) : (
            <>
              <button onClick={() => navigate("/login")}>Login to your dashboard</button>
              <button onClick={() => navigate("/signup")}>Sign up</button>
            </>
          )}
        </div>
      </div>
      <div className="navbar">
        <div className="logo-nav shonw">
         <img
            src="/AGRICVERSE_LOGO.png"
            alt="AgricVerse Logo"
            style={{ height: 40, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
        </div>

        <nav className="navtt">
          <div className="logo-nav">
             <img
            src="/AGRICVERSE_LOGO.png"
            alt="AgricVerse Logo"
            style={{ height: 40, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
          </div>
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="/marketplace">Marketplace</a>
            </li>
            <li>
              <a href="mailto:support@agricverse.com">Contact</a>
            </li>
          </ul>
        </nav>

        <div className="toggle-btn shonw" onClick={toggleNavbart}>
          <i className="fas fa-bars"></i>
        </div>
        <div className="signup-nav-btn disp">
          <LanguageToggle />
          {isAuthenticated ? (
            <>
              <span className="user-welcome">Welcome, {user?.user_name || 'User'}</span>
              <button onClick={() => navigate(getDashboardPath())}>Dashboard</button>
            </>
          ) : (
            <>
              <button onClick={() => navigate("/login")}>Login to your dashboard</button>
              <button onClick={() => navigate("/signup")}>Sign up</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
